<template>
  <div class="container">
    <div class="quote-section mb-5">
      <div class="quote-main">
          <svg xmlns="http://www.w3.org/2000/svg" width="55"  viewBox="0 0 70 66" fill="none" >
            <path d="M69.5312 9.57031C69.5312 10.7422 69.4661 12.2721 69.3359 14.1602C69.2708 16.0482 69.1732 18.1315 69.043 20.4102C68.9128 22.6237 68.75 25 68.5547 27.5391C68.3594 30.013 68.1641 32.4544 67.9688 34.8633C67.513 40.5273 66.9922 46.582 66.4062 53.0273C66.4062 54.9805 65.918 56.7383 64.9414 58.3008C63.9648 59.8633 62.6953 61.1979 61.1328 62.3047C59.5703 63.3464 57.8125 64.1602 55.8594 64.7461C53.9062 65.2669 51.9531 65.5273 50 65.5273C48.3724 65.5273 46.8099 65.332 45.3125 64.9414C43.8151 64.4857 42.4805 63.8346 41.3086 62.9883C40.1367 62.1419 39.1927 61.0677 38.4766 59.7656C37.8255 58.3984 37.5 56.7708 37.5 54.8828C37.5 54.1016 37.5651 53.3203 37.6953 52.5391C37.8255 51.6927 38.0208 50.8138 38.2812 49.9023C39.1276 46.7773 40.1042 43.3594 41.2109 39.6484C42.3177 35.8724 43.4245 32.1289 44.5312 28.418C45.7031 24.707 46.8099 21.1914 47.8516 17.8711C48.9583 14.4857 49.9349 11.6211 50.7812 9.27734C51.888 6.15234 53.4505 3.84115 55.4688 2.34375C57.5521 0.78125 59.6354 0 61.7188 0C63.8021 0 65.625 0.813802 67.1875 2.44141C68.75 4.00391 69.5312 6.38021 69.5312 9.57031ZM32.0312 9.57031C32.0312 10.7422 31.9661 12.2721 31.8359 14.1602C31.7708 16.0482 31.6732 18.1315 31.543 20.4102C31.4128 22.6237 31.25 25 31.0547 27.5391C30.8594 30.013 30.6641 32.4544 30.4688 34.8633C30.013 40.5273 29.4922 46.582 28.9062 53.0273C28.9062 54.9805 28.418 56.7383 27.4414 58.3008C26.4648 59.8633 25.1953 61.1979 23.6328 62.3047C22.0703 63.3464 20.3125 64.1602 18.3594 64.7461C16.4062 65.2669 14.4531 65.5273 12.5 65.5273C10.8724 65.5273 9.3099 65.332 7.8125 64.9414C6.3151 64.4857 4.98047 63.8346 3.80859 62.9883C2.63672 62.1419 1.69271 61.0677 0.976562 59.7656C0.325521 58.3984 0 56.7708 0 54.8828C0 54.1016 0.0651042 53.3203 0.195312 52.5391C0.325521 51.6927 0.520833 50.8138 0.78125 49.9023C1.6276 46.7773 2.60417 43.3594 3.71094 39.6484C4.81771 35.8724 5.92448 32.1289 7.03125 28.418C8.20312 24.707 9.3099 21.1914 10.3516 17.8711C11.4583 14.4857 12.4349 11.6211 13.2812 9.27734C14.388 6.15234 15.9505 3.84115 17.9688 2.34375C20.0521 0.78125 22.1354 0 24.2188 0C26.3021 0 28.125 0.813802 29.6875 2.44141C31.25 4.00391 32.0312 6.38021 32.0312 9.57031Z" fill="#A24F00"/>
          </svg>
          <span class="quote-main-text">
            Tuberculosis teaches us that we are only as safe as the most vulnerable among us.
          </span>
  
          <svg xmlns="http://www.w3.org/2000/svg" width="55" viewBox="0 0 70 66" fill="none">
            <path d="M0.531197 9.56632C0.531197 10.7377 0.59552 12.267 0.724159 14.1542C0.788483 16.0415 0.884964 18.1239 1.01361 20.4016C1.14225 22.6143 1.30305 24.9896 1.49602 27.5276C1.68898 30.0005 1.88194 32.4409 2.07491 34.8487C2.52515 40.5104 3.03973 46.5626 3.61862 53.0052C3.61862 54.9575 4.10103 56.7146 5.06585 58.2765C6.03067 59.8383 7.28493 61.1724 8.82864 62.2787C10.3724 63.3199 12.109 64.1334 14.0387 64.7191C15.9683 65.2397 17.8979 65.5 19.8276 65.5C21.4356 65.5 22.9793 65.3048 24.4587 64.9143C25.9381 64.4588 27.2567 63.808 28.4145 62.962C29.5723 62.116 30.5049 61.0422 31.2124 59.7407C31.8557 58.3741 32.1773 56.7471 32.1773 54.8599C32.1773 54.079 32.1129 53.2981 31.9843 52.5171C31.8557 51.6711 31.6627 50.7926 31.4054 49.8815C30.5692 46.7578 29.6044 43.3413 28.511 39.6319C27.4175 35.8574 26.324 32.1155 25.2306 28.4061C24.0728 24.6967 22.9793 21.1826 21.9502 17.8636C20.8567 14.4796 19.8919 11.6162 19.0557 9.27347C17.9623 6.14978 16.4186 3.83954 14.4246 2.34277C12.3663 0.780924 10.308 0 8.24975 0C6.19147 0 4.39047 0.813463 2.84676 2.44039C1.30305 4.00224 0.531197 6.37755 0.531197 9.56632ZM37.5803 9.56632C37.5803 10.7377 37.6446 12.267 37.7732 14.1542C37.8375 16.0415 37.934 18.1239 38.0627 20.4016C38.1913 22.6143 38.3521 24.9896 38.5451 27.5276C38.738 30.0005 38.931 32.4409 39.124 34.8487C39.5742 40.5104 40.0888 46.5626 40.6677 53.0052C40.6677 54.9575 41.1501 56.7146 42.1149 58.2765C43.0797 59.8383 44.334 61.1724 45.8777 62.2787C47.4214 63.3199 49.1581 64.1334 51.0877 64.7191C53.0174 65.2397 54.947 65.5 56.8766 65.5C58.4847 65.5 60.0284 65.3048 61.5078 64.9143C62.9872 64.4588 64.3057 63.808 65.4635 62.962C66.6213 62.116 67.554 61.0422 68.2615 59.7407C68.9047 58.3741 69.2263 56.7471 69.2263 54.8599C69.2263 54.079 69.162 53.2981 69.0334 52.5171C68.9047 51.6711 68.7117 50.7926 68.4545 49.8815C67.6183 46.7578 66.6535 43.3413 65.56 39.6319C64.4665 35.8574 63.3731 32.1155 62.2796 28.4061C61.1218 24.6967 60.0284 21.1826 58.9992 17.8636C57.9058 14.4796 56.941 11.6162 56.1048 9.27347C55.0113 6.14978 53.4676 3.83954 51.4736 2.34277C49.4154 0.780924 47.3571 0 45.2988 0C43.2405 0 41.4395 0.813463 39.8958 2.44039C38.3521 4.00224 37.5803 6.37755 37.5803 9.56632Z" fill="#A24F00"/>
          </svg>
      </div>
      <span class="quote-sub-text">
        Paul Farmer
      </span>
    </div>
    <div class="row mb-5">
      <div class="col-md-6 col-sm-12">
        <img class="donation-image" src="https://imgur.com/EzbM9bX.png" />
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="frame">
          <div class="heading">Donate Today</div>
          <div class="div">Bank of Punjab</div>
          <div class="div">6010047977300011</div>
          <div class="div">Habib Metropolitan Bank</div>
          <div class="div">6041220620714123190</div>
          <p class="p">
            Every donor is always pleasantly welcome to check all the income and expenditure of Shaheen T.B. Foundation.
          </p>
          <div class="div-2">
            <input type="text" class="input-field">
            <button class="button text-wrapper-3">
              Get my Donations
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  
}
</script>

<style lang="scss">
  .frame {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 50px;
  position: relative;
  background-color: #ffffff;
  border-radius: 0px 20px 20px 0px;
}

.frame .text-wrapper {
  position: relative;
  width: fit-content;
  margin-top: -1px;
  font-family: "Poppins-ExtraBold", Helvetica;
  font-weight: 800;
  color: #a24f00;
  font-size: 48px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
  white-space: nowrap;
}

.frame .div {
  position: relative;
  width: fit-content;
  font-family: "Poppins-Light", Helvetica;
  font-weight: 300;
  color: #000000;
  font-size: 24px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.frame .text-wrapper-2 {
  position: relative;
  width: fit-content;
  font-family: "Poppins-Light", Helvetica;
  font-weight: 300;
  color: #000000;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.frame .p {
  position: relative;
  width: 387px;
  font-family: "Poppins-Light", Helvetica;
  font-weight: 300;
  color: #000000;
  font-size: 12px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.frame .div-2 {
  align-items: flex-start;
  gap: 15px;
  display: inline-flex;
  justify-content: center;
  position: relative;
  flex: 0 0 auto;
}

.frame .input-field {
  position: relative;
  width: 324px;
  height: 48px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 0.5px solid;
  border-color: #d4b69a;
  box-shadow: 0px 4px 49px #00000026;
}

.frame .button {
  align-items: center;
  gap: 10px;
  padding: 14px 27px;
  background-color: #a24f00;
  border-radius: 8px;
  overflow: hidden;
  display: inline-flex;
  justify-content: center;
  position: relative;
  flex: 0 0 auto;
  border: none;
}

.frame .button:hover { 
  background-color: #7e3d01;
}

.frame .text-wrapper-3 {
  position: relative;
  width: fit-content;
  margin-top: -1px;
  font-family: "Poppins-Medium", Helvetica;
  font-weight: 500;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.donation-image { 
  width: 100%;
}

.quote-main-text { 
  color: #A24F00;
  text-align: center;
  font-size: 32px;
  font-weight: 100;
  line-height: normal;
}

.quote-main { 
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 27px;
}

.quote-sub-text { 
  color: #BABABA;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 7.6px;
  text-transform: uppercase;
}

.quote-section { 
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 31px;
  margin-bottom: 25px;
}
</style>